import PropTypes from 'prop-types';
import {getNextThemeIcon} from '../utils/theme';


export default function LandingPage({theme, onToggleTheme}) {
    const nextIcon = getNextThemeIcon(theme);
    return (
        <div className="landing" data-theme={theme}>
            <nav className="landing-nav">
                <div className="landing-nav-right">
                    <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
                        {nextIcon}
                    </button>
                    <a href="/?signin" className="landing-signin">Sign in</a>
                </div>
            </nav>
            <main className="landing-main">
                <div className="landing-hero">
                    <div className="landing-hero-text">
                        <h1 className="landing-hero-title">CHECKLISTS<br/>GURU</h1>
                        <div className="landing-hero-divider"/>
                        <p className="landing-hero-sub">Master your to-dos with expert guidance</p>
                    </div>
                </div>

            </main>
            <footer className="landing-footer">
                <span className="landing-footer-copy">© {new Date().getFullYear()} checklists.guru</span>
                <a className="landing-footer-contact" href="mailto:info@checklists.guru">info@checklists.guru</a>
            </footer>
        </div>
    );
}

LandingPage.propTypes = {
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
};
